define('modules/Cart/CartItemNotesService',[
        'jquery',
        'global/all',
        'plugins/jquery.proxyRequest'
    ],
    function($, Roc) {
        'use strict';

        /**
         * Updates notes for cart item
         * @param {any} itemId
         * @param {any} note
         */
        function updateItemNote(itemId, note) {
            var request = {
                'itemId': itemId,
                'note': note,
                'orderId': '{orderId}'
            };

            return $.proxyRequest({
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(request),
                contentType: 'application/json; charset=utf-8',
                url: 'api/store/item/notes/',
                complete: function (xhr) {
                    Roc.Logger.info('ItemNotesService -> updateItemNote');
                    Roc.Logger.info(xhr);
                }
            });
        }

        var CartItemNotesService = {
            updateItemNote: updateItemNote
        };

        Roc.Logger.debug('CartItemNotesService.js Loaded:', CartItemNotesService);

        return CartItemNotesService;


    });
